
import { Layout } from "../layout";
import { userRoutes } from "./userRoutes";


export const routes = () => {
  return [
    {
      element: <Layout />,
      children: [...userRoutes()],
    },
  ];
};